import { authService } from "../../Services/authServices/requests.ts";
import { store } from "../Store/index.js";
import { ChangeTextVisibility } from "./index.js";

// User Actions
export function SignIn(user){
    try {
        localStorage.setItem("user", JSON.stringify(user))
        return{
            type: 'SignIn',
            info: "SignIn",
            payload: user
        }
    } catch (error) {
        localStorage.clear();
        localStorage.setItem("user", JSON.stringify(user))
        return{
            type: 'SignIn',
            info: "SignIn",
            payload: user
        }
    }
}

export function LogOut(){
    authService.SignOut();
    let user = JSON.stringify({
        user: '',
        access_token: '',
        isLogged: false
    })
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.setItem("user", user);
    store.dispatch(ChangeTextVisibility(false))
    return{
        type: 'LogOut',
        info: "LogOut",
    }
}

export function ChangeUserInfo(newUser){
    localStorage.setItem("user", JSON.stringify(newUser))
    return{
        type: 'ChangeUserInfo',
        info: "ChangeUserInfo",
        payload: newUser
    }
}
